import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  paperProps: {
    backgroundColor: "#F8F9FC !important",
    height: "calc(100% - 110px) !important",
    borderBottomRightRadius: "10px",
    margin: "95px 15px 15px 0",
  },
  modalProps: {
    zIndex: "99999 !important" as unknown as number,
    width: 0,
  },
  icon: {
    cursor: "pointer",
    fontSize: "14px",
  },
  image: {
    width: "240px",
    borderRadius: "8px",
  },
  containerPictures: {
    marginTop: "24px",
  },
}));

export default styles;
